import { Component, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProgramsService } from 'src/app/_services/generatedServices';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ToasterService } from 'src/app/_services/toaster.service';
import { ClientSummaryDTO, ProgramAssignmentViewModel } from 'src/app/_models/generatedModels';
import { dateAsUTCNoTime } from 'src/app/_helpers/extensions.module';

@Component({
  selector: 'assign-program',
  templateUrl: 'assign-program.component.html'
})
export class AssignProgramComponent implements OnChanges {
  initialized = false;
  public formGroup: FormGroup;
  submitComplete: Promise<{}> | undefined;
  openAssignProgramValue: boolean;

  @Input()
    programId: number;

  @Input()
    programName: string;

    @Input()
    get openAssignProgram() {
        return this.openAssignProgramValue;
    }

    set openAssignProgram(val) {
        this.openAssignProgramValue = val;
        this.openAssignProgramChange.emit(this.openAssignProgramValue);
    }

    @Output()
    openAssignProgramChange = new EventEmitter<boolean>();

  constructor(private programData: ProgramsService, private auth: AuthenticationService, private fb: FormBuilder, private toastr: ToasterService) { }

  ngOnChanges(): void {
    this.setupForm();
  }

  setupForm() {
    this.formGroup = this.fb.group({
      clientUserId: [null, Validators.required],
      programId: [this.programId],
      assignedByUserId: [this.auth.user.id],
      startDate: [null, Validators.required]
    });

    this.initialized = true;
  }

  closeAssignProgramDialog(status: string) {
    if (status === 'save') {
        if (!this.formGroup.valid) {
            this.formGroup.markAllControlsDirty();
            return;
        }

        this.submitComplete = new Promise((resetButton:any, reject) => {
          const formData: ProgramAssignmentViewModel = Object.assign({}, this.formGroup.getRawValue());
          formData.startDate = dateAsUTCNoTime(formData.startDate);
          formData.isPurchasedProgram = false;
            this.programData.assignProgramToClient(formData).subscribe(results => {
                this.toastr.success('Program has been assigned', 'Success');
                this.openAssignProgram = false;
                resetButton();
            }, error => resetButton());
        });

    } else {
        this.openAssignProgram = false;
    }
  }
}
